import useAnswerForm from '../../../hooks/useAnswerForm';
import { FormContainer, FormTextarea } from '../../form';
import { Button } from '../../ui/button';
import { Alert, AlertDescription } from '../../ui/alert';

/**
 * NewAnswerPage component allows users to submit an answer to a specific question.
 */
const NewAnswerPage = () => {
  const { text, textErr, setText, postAnswer } = useAnswerForm();

  return (
    <FormContainer>
      <FormTextarea
        title={'Answer Text'}
        id={'answerTextInput'}
        val={text}
        setState={setText}
        err={textErr}
      />
      <div className='flex flex-col sm:flex-row sm:justify-between items-center mt-6'>
        <Button onClick={postAnswer} className='bg-blue-500 hover:bg-blue-600 mb-4 sm:mb-0'>
          Post Answer
        </Button>
        <Alert className='bg-gray-100 border-gray-200 p-2'>
          <AlertDescription className='text-xs text-gray-600'>
            * indicates mandatory fields
          </AlertDescription>
        </Alert>
      </div>
    </FormContainer>
  );
};

export default NewAnswerPage;
